/*******************************************************************************
* Licensed Materials - Property of HCL
* (c) Copyright HCL Technologies Ltd. 2020, 2023. All Rights Reserved.

* Note to U.S. Government Users Restricted Rights:
* Use, duplication or disclosure restricted by GSA ADP Schedule
**************************************************************/

import React from "react";
import DelayChain from "./DelayChain";

const DelayAnalysisRoom = () => {
    return (
        <a-entity class="Delay Analisys Room">
            <a-entity position="0 1.7 -4">
                <DelayChain width={10} height={2.5} />
            </a-entity>
        </a-entity>
    );
};

export default DelayAnalysisRoom;